import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';
import { Router } from '@angular/router';
import { environment } from '../../environments/environment';
import { DataService } from '../services/data.service';

/** Dieser Code definiert einen Angular Interceptor namens TokenInterceptorService,
 * der die HTTP-Anfrage abfängt und entsprechend der Anforderungen modifiziert.
 *
 In der intercept Methode wird zunächst eine neue Anfrage erstellt, indem der Request-Parameter mit addCookie-Methode modifiziert wird, um den aktuellen Session-Cookie hinzuzufügen. Danach wird geprüft, ob die Anfrage an die API geht, indem die URL mit der apiUrl aus der Umgebungsvariable verglichen wird.

 Wenn kein Token vorhanden ist, wird der Benutzer auf die Login-Seite weitergeleitet.

 Wenn die Anfrage jedoch eine PDF-Generierung ist, wird das Token nicht hinzugefügt, da dies zu Problemen bei der PDF-Generierung führen kann.

 Schließlich wird die modifizierte Anfrage an den nächsten Handler in der Kette weitergeleitet, und die HTTP-Antwort wird mithilfe der pipe-Methode abgefangen, um Fehler zu behandeln.
 */

@Injectable({
  providedIn: 'root',
})
export class TokenInterceptorService {
  apiUrl = environment.apiBaseUrl;

  constructor(
    private authService: AuthService,
    private router: Router,
    private dataService: DataService
  ) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    request = this.addCookie(request);

    const isApiUrl = request.url.startsWith(this.apiUrl + '/api/v1');
    const pdfGeneration = request.url.startsWith(this.apiUrl + '/api/v1/print');
    let authToken =
      localStorage.getItem('token') ??
      this.authService.accessToken ??
      this.authService.sessionToken;
    if (!authToken && !this.authService.contextNative$.value) {
      console.log('[TOKEN INTERCEPTOR]>[ROUTER]: No Auth-token Navigate Login');
      this.router.navigate(['/']);
    }

    if (this.authService.contextNative$.value) {
      console.log('[TOKEN INTERCEPTOR]: Add Session Token');
      if (this.authService.sessionToken) {
        authToken = this.authService.sessionToken;
        request = this.addAuthHeader(request, authToken);
      }
    }

    if (pdfGeneration) {
      if (authToken) {
        request = this.addAuthHeaderPDF(request, authToken);
      }
    }

    if (isApiUrl && authToken && !pdfGeneration) {
      if (authToken) {
        request = this.addAuthHeader(request, authToken);
      }
    }

    return next.handle(request).pipe(
      catchError((err) => {
        console.log(err);

        return this.handleResponseError(err, request, next);
      })
    );
  }

  protected _handleAuthUnauthorized(
    error: any,
    request?: HttpRequest<any>,
    next?: HttpHandler
  ): Observable<HttpEvent<any>> {
    switch (error.code ?? false) {
      case 67:
      case -69 /*
        if (!this.authService.getRefreshToken() || this.authService.getRefreshTokenRemainingTime() <= 0) {
          this.store.dispatch(AuthActions.userLoggedOut());
          break;
        }*/:
        // return this.refreshJwtToken(request as HttpRequest<any>, next as HttpHandler);
        break;
      case -70:
        // this.store.dispatch(AuthActions.userLoggedOut());
        break;
      default:
        // this.coreNavService.back();
        break;
    }
    return throwError(error);
  }

  private addCookie(request: HttpRequest<any>): HttpRequest<any> {
    return request.clone({
      withCredentials: true,
    });
  }

  private addAuthHeader(
    request: HttpRequest<any>,
    authToken: string
  ): HttpRequest<any> {
    const headers: { [name: string]: string | string[] } = {
      Authorization: `Bearer ${authToken}`,
      // 'Content-Type' : 'application/json'
    };
    return request.clone({
      setHeaders: headers,
    });
  }

  private addAuthHeaderPDF(
    request: HttpRequest<any>,
    authToken: string
  ): HttpRequest<any> {
    const headers: { [name: string]: string | string[] } = {
      Authorization: `Bearer ${authToken}`,
      'Content-Type': 'application/json',
      Accept: 'application/pdf',
    };

    return request.clone({
      setHeaders: headers,
    });
  }

  private handleResponseError(
    error: HttpErrorResponse,
    request?: HttpRequest<any>,
    next?: HttpHandler
  ): Observable<HttpEvent<any>> {
    switch (error.status) {
      case 403:
        // this.store.dispatch(AuthActions.userLoggedOut());
        // this.router.navigate( [ authRoutePaths.forbidden ] );
        // return throwError(error.error);
        break;
      case 401:
        console.log('[TOKEN INTERCEPTOR]: 401 -> Logout');
        this.dataService.logout();
        // this.authService.authenticate();
        break;
      case 503:
        return throwError(error);
      case 428:
        return throwError(error);
      default:
        console.log('[TOKEN INTERCEPTOR]: Default -> Logout');
        this.dataService.logout();
        return throwError(error.error);
    }
    console.log('[TOKEN INTERCEPTOR]: Default -> Logout');
    this.dataService.logout();
    return throwError(error.error);
  }
}
